import {SearchIcon} from '@prtimes-basis/icons';
import {WhiteLogoIcon} from '../icons';
import styles from './pc-header.module.css';

export function PcHeader() {
  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <div className={styles.top}>
          <div className={styles.left}>
            <WhiteLogoIcon />
            <span className={styles.titleText}>
              プレスリリース・ニュースリリース配信サービスのPR TIMES
            </span>
          </div>
          <div className={styles.right}>
            <span>プレスリリースを受信</span>
            <span>企業登録申請</span>
            <span>ログイン</span>
            <SearchIcon variant='white' />
          </div>
        </div>
        <div className={styles.bottom}>
          {[
            'Top',
            'テクノロジー',
            'モバイル',
            'アプリ',
            'エンタメ',
            'ビューティー',
            'ファッション',
            'ライフスタイル',
            'ビジネス',
            'グルメ',
            'スポーツ',
          ].map((text) => (
            <span key={text} className={styles.bottomItem}>
              {text}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
